import { React, StyledProps } from '@api'
import { Popover, Typography, Card, CardContent, CardActions, CircularProgress } from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'
import { SecondaryButton, TextInput, ColorField } from 'centric-ui-components'

const styles = (theme) => ({
  card: {
    width: 300,
    height: 466,
    overflow: 'hidden'
  },
  title: {
    height: 64,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    borderBottom: '1px solid #dedede',
    color: 'rgba(27, 27, 27, 0.87)',
    justifyContent: 'left',
    padding: `0 ${theme.spacing() * 3}px`
  },
  cardContent: {
    padding: 0,
    minHeight: 64,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  titleText: {
    fontWeight: 'normal',
    color: 'rgba(27, 27, 27, 0.87)',
    flex: 1,
    width: '100%'
  },
  cardActions: {
    borderTop: '1px solid #dedede',
    display: 'flex',
    justifyContent: 'flex-end',
    bottom: 0,
    position: 'absolute',
    width: '100%'
  },
  contentContainer: {
    padding: `${(theme.spacing() * 2 + 4)}px ${theme.spacing() * 3}px 0`
  },
  buttonProgress: {
    color: '#4183F3'
  },
  loading: {
    height: 350,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
})

interface MyProps extends StyledProps {
  anchorEl?: any,
  title?: string,
  onClickCancel?: (e) => void,
  data?: object,
  type?: string,
  onClickPublish?: (e) => void,
  anchorVertical?: any,
  anchorHorizontal?: any,
  transformVertical?: any,
  transformHorizontal?: any,
  onClickColor?: (e) => void,
  onChangeInput?: (e) => void,
  error?: object,
  inProgress?: boolean
  loading?: boolean
}

@(withStyles as any)(styles)
export class PublishPLMSpecificationPopupComponent extends React.Component <MyProps & any> {
  render() {
    const {
            anchorEl,
            classes,
            title,
            onClickCancel,
            data,
            type,
            onClickPublish,
            anchorVertical,
            anchorHorizontal,
            transformVertical,
            transformHorizontal,
            onClickColor,
            onChangeInput,
            inProgress,
            error,
            loading
          } = this.props

    return (
        <Popover
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            anchorOrigin={{
              vertical:   anchorVertical,
              horizontal: anchorHorizontal
            }}
            transformOrigin={{
              vertical:   transformVertical,
              horizontal: transformHorizontal
            }}
            onClose={onClickCancel}
        >
          <Card className={classes.card}>
            <CardContent classes={{root: classes.cardContent}}>
              <div className={classes.title}>
                <Typography
                    classes={{h6: classes.titleText}}
                    variant={'h6'}>
                  {title}
                </Typography>
              </div>
              {loading 
                ? <div className={classes.loading}>
                    <CircularProgress color={'secondary'}/>
                  </div>
                : <div className={classes.contentContainer}>
                  <TextInput
                      name={'name'}
                      label={'Color'}
                      required
                      value={data.name}
                      error={error['name']}
                      placeholder={`Enter ${type}`}
                      onChange={onChangeInput}
                  />
                  <TextInput
                      name={'description'}
                      label={'Subtitle'}
                      value={data.description}
                      placeholder={`Enter Subtitle`}
                      onChange={onChangeInput}
                  />
                  {type === 'colors' && <ColorField editMode required error={!!error.hex} color={data.hex} label={'Hex'} onClickColor={onClickColor}/>}
                  {type === 'colors' && <ColorField editMode required error={!!error.rgb} color={data.rgb} label={'RGB'} onClickColor={onClickColor}/>}
                 </div>
              }
              <CardActions classes={{root: classes.cardActions}}>
                <SecondaryButton onClick={onClickCancel}>
                  CANCEL
                </SecondaryButton>
                <SecondaryButton onClick={onClickPublish}
                                 disabled={inProgress}
                                 icon={{
                                   component: inProgress
                                              ? <CircularProgress size={24} className={classes.buttonProgress}/>
                                              : null,
                                   position:  'right'
                                 }}>
                  PUBLISH
                </SecondaryButton>
              </CardActions>
            </CardContent>
          </Card>
        </Popover>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/libraries/components/PublishPLMSpecificationPopup.tsx